import axios from "axios";
import JwtService from "@/core/services/jwt.service";
// import { get } from "@vueuse/core";

const location = "BR";
const DEV_MODE = false; // Set to true for development mode, false for production
const TEST_MODE = true; // Set to true for test mode, false for production

/**
 * Service to call HTTP request via Axios
 */
const ApiService = {
    init() {
        // Override explicito da maquina de desenvolvimento; nao muda o destino de producao.
        if (process.env.VUE_APP_BACKEND_URL) {
            axios.defaults.baseURL = process.env.VUE_APP_BACKEND_URL.replace(/\/?$/, "/");
            return;
        }
        if(DEV_MODE) {
            axios.defaults.baseURL = "http://localhost/backend-spirit/";
        } else {
            if(location == "US") {
                axios.defaults.baseURL = "https://backend.clinicspirit.com/";
            } else {
                if(TEST_MODE) {
                    axios.defaults.baseURL = "https://backendtest.micrologos.com.br/";
                } else {
                    axios.defaults.baseURL = "https://backend.micrologos.com.br/";
                }
            }
        }
    }, 

    getBackendUrl() {
        return axios.defaults.baseURL;
    }, 

    getBackendChatUrl() {
        let urls = [
            "https://backendchat1.micrologos.com.br", 
            "https://backendchat2.micrologos.com.br", 
            "https://backendchat3.micrologos.com.br", 
            "https://backendchat4.micrologos.com.br"
        ];

        return urls[
            Math.floor(Math.random() * urls.length)
        ];
    }, 

    getClinicUrl() {
        if(location == "US") {
            return "https://clinicspirit.com/";
        } else {
            if(TEST_MODE) {
                return "https://clm.micrologos.com.br/";
            } else {
                return "https://clinic.micrologos.com.br/";
            }
        }
    },

    getChatUrl() {
        if(location == "US") {
            return "https://chat.clinicspirit.com/";
        } else {
            return "https://chat.micrologos.com.br/";
        }
    },

    setHeader() {
        axios.defaults.headers.common[
            "Authorization"
        ] = `Token ${JwtService.getToken()}`;
    },

    query(resource, params) {
        return axios.get(resource, params).catch(error => {
            // console.log(error);
            throw new Error(`[KT] ApiService ${error}`);
        });
    },

    /**
     * Send the GET HTTP request
     * @param resource
     * @param slug
     * @returns {*}
     */
    async get(resource, slug = "", retries = 2, delay = 500) {
        try {
            return await axios.get(`${resource}/${slug}`);
        } catch (error) {
            if(retries <= 0) {
                throw new Error(`[KT] ApiService ${error}`);
            }
            await new Promise(resolve => setTimeout(resolve, delay));
            return ApiService.get(resource, slug, retries - 1, delay * 2);
        }
    },

    getFile(resource, slug = "") {
        return axios({
            url: resource + "/" + slug,
            method: "GET",
            responseType: "blob"
        }).catch(error => {
            // console.log(error);
            throw new Error(`[KT] ApiService ${error}`);
        });
    },

    /**
     * Set the POST HTTP request
     * @param resource
     * @param params
     * @returns {*}
     */
    postOnce(resource, params, config = {}) {
        return axios.post(resource, params, config);
    },

    async post(resource, params, retries = 2, delay = 500) {
        try {
            return await axios.post(`${resource}`, params);
        } catch (error) {
            if(retries <= 0) {
                return new Promise(resolve => setTimeout(() => resolve({data: error.response.data}), 100));
            }
            await new Promise(resolve => setTimeout(resolve, delay));
            return ApiService.post(resource, params, retries - 1, delay * 2);
        }
    },

    /**
     * Send the UPDATE HTTP request
     * @param resource
     * @param slug
     * @param params
     * @returns {IDBRequest<IDBValidKey> | Promise<void>}
     */
    update(resource, slug, params) {
        return axios.put(`${resource}/${slug}`, params);
    },

    /**
     * Send the PUT HTTP request
     * @param resource
     * @param params
     * @returns {IDBRequest<IDBValidKey> | Promise<void>}
     */
    put(resource, params) {
        return axios.put(`${resource}`, params);
    },

    /**
     * Send the DELETE HTTP request
     * @param resource
     * @returns {*}
     */
    delete(resource) {
        return axios.delete(resource).catch(error => {
            // console.log(error);
            throw new Error(`[RWV] ApiService ${error}`);
        });
    }
};

export default ApiService;
